import { IconCheck } from '@tabler/icons-react';
import orders from './Orders.module.css';

/**
 * GRN kartının altındaki "GRN created" satırı (`satin-alma-akisi.jpeg` "Delivery & GRN"): yeşil
 * onay ikonu, başlık ve kişi ile zaman. Başlık kırılmaz; dar ekranda kişi ve zaman ikon hizasında
 * alt satıra iner (M12c-R30; Responsive kurallar).
 */
export function ReceiptCreated({ label, meta }: { label: string; meta: string }) {
  return (
    <p className={orders.created}>
      <span className={orders.createdIcon} aria-hidden>
        <IconCheck size={16} />
      </span>
      <span className={orders.createdLabel}>{label}</span>
      <span className={orders.createdMeta}>{meta}</span>
    </p>
  );
}
